import { FuseAnimate, FusePageCarded } from "@fuse";
import _ from "@lodash";
import { Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import PainelToggleButton from "app/Core/Components/Filter/PainelToggleButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdGroups } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import FilterApp from "../../Core/Components/Filter/FilterApp";
import EmpresaDepartamentoDialog from "./EmpresaDepartamentoDialog";
import EmpresaDepartamentoList from "./EmpresaDepartamentoList";
import * as Actions from "./Store/Actions/EmpresaDepartamentoActions";
import reducer from "./Store/Reducers/EmpresaDepartamentoReducer";

const filterApp = [
    { "label": "Nome", "value": "UPPER(pessoaformulario.formulario->>''nome'')", "tipo": "string" },
    { "label": "Código", "value": "idpessoaformulario", "tipo": "int" }
];

const styles = theme => ({
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

class EmpresaDepartamentoApp extends XAPPComponent {

    state = {
        acoes: null
    };

    getAcoes = () => {
        return this.state.acoes;
    };

    setAcoes = (_AValue) => {
        this.setState({ acoes: _AValue });
    };

    listFilter = (_AFilter) => {
        let { xappRouteParams } = this.props;
        const { target = null } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        this.props.list("SELECIONAR", xappRouteParams, _AFilter, 1, target);
    };

    render() {
        const { classes, isLookup, onChange, filter, isButton } = this.props;
        const xappRouteParams = this.props.match.params;

        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageCarded
                        classes={{
                            contentWrapper: "p-0",
                            contentCardWrapper: "p-16 sm:p-24 pb-80",
                            leftSidebar: "w-256 border-0",
                            header: "w-full min-h-48 h-48 max-h-48 flex",
                            topBg: "min-h-48 h-48"
                        }}
                        header={
                            <div className="w-full flex items-center">
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Typography className="flex text-white items-center" variant="h6">
                                        <MdGroups className="text-24 text-white mx-8" />
                                        {"Departamentos"}
                                    </Typography>
                                </FuseAnimate>
                                <div className="flex-1" />
                                <PainelToggleButton />
                                <FilterApp
                                    filters={filterApp}
                                    xappRouteParams={xappRouteParams}
                                    pesquisar={(ev) => this.listFilter(ev)}
                                />
                            </div>
                        }
                        content={
                            !isButton ?
                                <EmpresaDepartamentoList
                                    isLookup={isLookup}
                                    onChange={onChange}
                                    filter={filter}
                                    xappRouteParams={xappRouteParams}
                                    setAcoes={this.setAcoes}
                                    listFilter={this.listFilter}
                                    getAcoes={this.getAcoes}
                                />
                                :
                                <div />
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                    {!isButton && !isLookup &&
                        <XAPPButton
                            id={"fab-add-departamento"}
                            className={classes.addButton}
                            type="Fab"
                            variant="contained"
                            color="primary"
                            iconProps="text-24 text-white"
                            onClick={() => { this.props.openNewDialog(); }}
                            icon={"add"}
                        />
                    }
                    <EmpresaDepartamentoDialog
                        xappRouteParams={xappRouteParams}
                    />
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        openNewDialog: Actions.openNewDialog
    }, dispatch);
}

function mapStateToProps({ EmpresaDepartamento }) {
    return {
        Depositos: EmpresaDepartamento.data,
    };
}

export default withReducer("EmpresaDepartamento", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaDepartamentoApp))));
